app.service('accountCartRetrieve', function (modal, loading, log, csrfToken, sessionStorage) {

	function saveMessage(message){
		sessionStorage.setItem('afterReloadMessage', message);
	}

	function action(action, cart, bundle) {
		loading.start();
		log.event({ id: 'laczenie-koszykow', f03: action });
		let data = {
			action: action,
			previousCartCookie: cart
		};
		function post(token) {
			data['_csrf'] = token;
			$.ajax({
				url: '/merge-carts.ltr',
				type: 'POST',
				data: data,
			success: function (json) {
				if (json.status === 'SUCCESS') {
					if(action == 'MERGE'){
						saveMessage(`<h2>Produkty zostały dodane do koszyka</h2>`);
						if(bundle){
							sessionStorage.setItem('cart-merge-bundle', 'true');
						}
					} else if(action == 'OVERRIDE_LAST'){
						saveMessage(`<h2>Wcześniejszy koszyk został usunięty</h2>`);
					} else if(action == 'OVERRIDE_CURRENT'){
						saveMessage(`<h2>Koszyk został przywrócony</h2>`);
					}
					loading.redirect('/cart.bhtml');
				} else {
					modal.alert('Błąd łączenia koszyków. Spróbuj ponownie');
				}
			},
			error: function () {
				modal.alert('Błąd w komunikacji łączenia koszyków. Spróbuj ponownie');
			}
		})}
		csrfToken.get(function (token) {
			post(token);
		});
	}

	return {
		action
	};
});
